import flowRight from 'lodash/flowRight'

import appContext from './application-context'
import setupEnvironment from './environment'
import setupGlobalFlash from './global-sf-flash'
import setupSolidReconciledStatus from './solid-reconciled-status'
import setupStimulus from './stimulus'
import setupTooltip from './tooltip'
import setupSegmentReadyToastGate from '@app/insights/setup/segment-ready-toast-gate'

export default (): void => {
  flowRight([
    setupEnvironment,
    setupSolidReconciledStatus,
    setupStimulus,
    setupGlobalFlash,
    setupTooltip,
    setupSegmentReadyToastGate,
  ])(appContext)
}
